var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{attrs:{"id":"loading-mask"}},[_vm._m(0)]):_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper"},[_c('span',{staticClass:"loading-dot loading-dot-spin"},[_c('i'),_c('i'),_c('i'),_c('i')])])
}]

export { render, staticRenderFns }